/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import { adminInstance } from '../../config/axios';
import CompareListDataTable from './compareListDataTable';
import Loader from '../loader/loader';

const CompareProductPrice = () => {
  const [loading, setLoading] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  const gameId = urlParams.get('gameId');
  const getAllComparedData = async () => {
    try {
      setLoading(true);
      const response = await adminInstance().post(
        'api/admin/get-price-compare',
        { gameId }
      );

      const { code, product } = response.data;
      setLoading(false);
      if (code === 200) {
        setLoading(false);
        setFilteredItems(product);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllComparedData();
  }, []);

  return (
    <Fragment>
      <Breadcrumb title='Product Price Compare' parent='Product' />
      <Container fluid={true}>
        <div className='admin-card'>
          <Card>
            <CardHeader>
              <h5>Price Compare</h5>
            </CardHeader>
            <CardBody>
              <div className='clearfix'></div>
              <div
                id='batchDelete'
                className='category-table user-list order-table coupon-list-delete'
              >
                {!loading ? (
                  filteredItems?.length > 0 ? (
                    <CompareListDataTable
                      multiSelectOption={true}
                      myData={filteredItems}
                      pageSize={10}
                      pagination={true}
                      class='-striped -highlight'
                    />
                  ) : (
                    <h5 className='text-danger'>Data does not found</h5>
                  )
                ) : (
                  <Loader />
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </Fragment>
  );
};
export default CompareProductPrice;
